import React from 'react';
import Footer from "./Footer";
import JoinUs from './JoinUs';

const ContactPAge = (props) => {
    
    return props === undefined ? <></> : (
        <>
            <div className="contactPage text-center">
                <h6>CONTACT</h6>
                <div className="container contactContainer">
                    <div className="row">
                        <div className="contactTextWrap col-lg-6 order-2 order-md-1">
                            <p className="headOffice">HEAD OFFICE</p>
                            <p className="officeAddress">{props.store.address}</p>
                            <p className="tel">T: {props.store.phone}</p>
                            <p className="email">E: {props.store.email}</p>
                        </div>
                        <div className="contactImageWrap col-lg-6 order-1 order-md-2 d-flex align-items-center "><iframe src={props.store.google_map} width="100%" height="300vmax" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe></div>
                    </div>
                </div>
            </div>
            <div className="joinus d-none d-lg-block">
            <JoinUs {...props} />
            </div>
            <div className="footer d-lg-none">
        <Footer />
      </div>
        </>
    );
};

export default ContactPAge;